import { init, configureScope } from '@sentry/browser';
import { dataLoader } from '../utilities/dataLoader';

/* global _OL_ORIGIN */

init({
  dsn: 'https://e0a6a8859034419180030aa83f4dc756@sentry.io/1186991',
  release: _RELEASE,
  environment: _BUILD_TYPE,
  sampleRate: _OL_ORIGIN === 'https://www.openlearning.com' ? 0.2 : 1,
});

configureScope((scope) => {
  scope.setUser({
    username: dataLoader('current-user-data'),
    id: dataLoader('current-user-id-data'),
  });
});
